var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5668419,38.4697209 L7.54183012,26.7024383 C6.81938996,25.995482 6.81938996,24.8492327 7.54183012,24.1422057 L10.1580651,21.5819731 C10.8805053,20.8749461 12.0519322,20.8749461 12.7743723,21.5819731 L20.8749955,29.5089069 L38.2256277,12.5302172 C38.9480678,11.8232609 40.1194947,11.8232609 40.8419349,12.5302172 L43.4581699,15.0904498 C44.18061,15.7974061 44.18061,16.9436554 43.4581699,17.6506824 L22.1831491,38.4697916 C21.4606367,39.1767479 20.289282,39.1767479 19.5668419,38.4697209 L19.5668419,38.4697209 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "check",
    fill: "currentColor",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.04e519355c9e4fea7af850424478fd03.svg";
export { ForwardRef as ReactComponent };